/**
 * Animals picture-tier vignettes (AUTHORING.md v3): one painted background per picture (public/vignettes/animals/<bg>.webp,
 * prompts docs/vignette-prompts.py, CREDITS.md) + the picture's posed object from core (`content/worlds/animals/pictures.ts`).
 * `elements` = every part the painting shows (each one is drawn + coloured in the picture lesson).
 */
import type { VignetteSpec, WorldVignettes } from '../../vignette/types';

const v = (id: string, elements: string[], overlay?: string[]): VignetteSpec => ({ id: `${id}-picture`, bg: id, elements, ...(overlay ? { overlay } : {}) });

const specs: VignetteSpec[] = [
  /* L1 */
  v('animals-cat', ['sky', 'ground', 'fence', 'sunflowers']),
  v('animals-fish', ['sky', 'ground', 'seaweed', 'stones', 'bubbles']),
  v('animals-remix-cat-bow', ['sky', 'ground', 'bushes', 'tulips']),
  v('animals-remix-cat-tiger', ['sky', 'ground', 'tallGrass', 'ferns']),
  v('animals-remix-cat-yawn', ['sky', 'ground', 'window', 'books']),
  /* L2 */
  v('animals-owl', ['sky', 'moon', 'stars', 'ground', 'log']),
  v('animals-bunny', ['sky', 'hills', 'ground', 'flowers']),
  v('animals-elephant', ['sky', 'river', 'ground', 'trees', 'bushes']),
  v('animals-remix-owl-glasses', ['sky', 'ground', 'books', 'pot']),
  v('animals-remix-owl-scarf', ['sky', 'ground', 'pines']),
  v('animals-remix-owl-sleepy', ['sky', 'clouds', 'hills', 'ground']),
  /* L3 */
  v('animals-turtle', ['sky', 'ground', 'pond', 'ferns', 'stones']),
  v('animals-hedgehog', ['sky', 'ground', 'trees', 'mushrooms']),
  v('animals-sheep', ['sky', 'clouds', 'mountains', 'ground']),
  v('animals-remix-turtle-star-shell', ['sky', 'stars', 'sea', 'ground', 'shells']),
  v('animals-remix-turtle-mushroom-house', ['sky', 'ground', 'pines', 'ferns']),
  v('animals-remix-turtle-goggles', ['sky', 'ground', 'coral', 'rocks', 'bubbles']),
  v('animals-remix-hedgehog-apples', ['sky', 'ground', 'path', 'trees']),
  v('animals-remix-hedgehog-scarf', ['sky', 'clouds', 'ground', 'fence']),
  v('animals-remix-hedgehog-ball', ['sky', 'hills', 'bushes', 'ground']),
  /* L4 */
  v('animals-fox', ['sky', 'mountains', 'ground', 'rocks']),
  v('animals-lion', ['sky', 'ground', 'rocks', 'dryGrass']),
  v('animals-penguin', ['sky', 'sea', 'ground', 'icebergs']),
  v('animals-remix-fox-pounce', ['sky', 'sun', 'ground', 'tallGrass']),
  v('animals-remix-fox-sleep', ['sky', 'moon', 'pines', 'ground']),
  v('animals-remix-fox-wave', ['sky', 'clouds', 'ground', 'hills', 'village']),
  v('animals-remix-lion-cub', ['sky', 'sun', 'bushes', 'ground']),
  v('animals-remix-lion-conductor', ['sky', 'stars', 'hills', 'ground']),
  v('animals-remix-lion-flower-mane', ['sky', 'ground', 'trees', 'tulips']),
  /* playground-only */
  v('animals-chick', ['sky', 'ground', 'stones', 'flowers']),
];

export const ANIMALS_VIGNETTES: WorldVignettes = { world: 'animals', specs };
